import { render, staticRenderFns } from "./BasePresignedImage.vue?vue&type=template&id=1b6f02ca&"
import script from "./BasePresignedImage.vue?vue&type=script&lang=js&"
export * from "./BasePresignedImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports